<template>
    <div>
        <LayoutBanner
            activeNav="艺讯"
            :topColor="topColor"
            bannerType="header index"
            :height="280"
        />
        <div class="container">
            <!-- title start -->
            <div class="title">
                <img class="bj" src="@/assets/images/news_title.png" />
                <div class="nav-list">
                    <div class="item " 
                    :class="{
                        'active':item.id == choose_class_id
                    }"
                    @click="handelClass(item.id)"
                    v-for="(item,index) in class_list" :key="index">{{ item.name }}</div>
                </div>
            </div>
            <!-- title end -->

            <!-- content start -->
            <div class="content">

                <!-- left start -->
                <div class="left">
                    <a-spin :spinning="loading">
                        <div class="news-list" v-if="search_result.list.length<=0">
                            <div style="width:80%;margin:15px auto;">
                                <a-empty description="暂无新闻" />
                            </div>
                        </div>
                        <div class="news-list" v-else>
                            <div class="item "
                             v-for="(item,index) in search_result.list" 
                             @click="handelNews(item)"
                             :class="{
                                 'not-img'  : !(item['img_cover']!=null && item['img_cover']!='')
                             }"
                             :key="index">
                                <div class="img" v-if="(item['img_cover']!=null && item['img_cover']!='')">
                                    <img :src="item['img_cover_full']" />
                                </div>
                                <div class="info">
                                    <div class="title">{{ item.name }}</div>
                                    <div class="tags">
                                        <span>发布时间：{{ item.cd }}</span>
                                        <span v-if="item.source">来源： {{ item.source }}</span>
                                        <span v-if="item.author">作者：{{ item.author }}</span>
                                    </div>
                                    <div class="desc" >
                                        {{ item.desc||'--' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a-spin>
                </div>
                <!-- left end -->


                <!-- right start -->
                <div class="right">
                    <div class="title">
                        <span>热门推荐</span>
                        <span class="s">大家都在看</span>
                    </div>
                    <div class="list" v-if="hot_news.length<=0" >
                        <div style="width:80%;margin:15px auto;">
                            <a-empty description="暂无新闻" />
                        </div>
                    </div>
                    <div class="list" v-else>
                        <div class="item" @click="handelNews(item)" v-for="(item,index) in hot_news" :key="index">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <!-- right end -->

            </div>
            <!-- content end -->

            <div class="pager">
                <pager :total="search_result.total||0" :limit="search_base.limit||0" @currentPage="changePage"></pager>
            </div>

        </div>
        <LayoutFooter />
    </div>
</template>


<script>
import pager from "@/components/other/pager";
import { getNews } from "../../xx-vue/services/news";
import { getNewsClass } from "../../xx-vue/services/newsClass";
export default {
    components: { pager },
    data(){
        return {
            topColor: "background-color: rgba(0, 0, 0, 0.3)",

            "search_base":{
                "page":1,
                "limit":10
            },

            "search_result":{
                "total":20,
                "list":[]
            },

            "loading":false,

            "hot_news"  : [],

            "class_list"    : [],

            "choose_class_id"   : 0,
        };
    },
    mounted(){

        this._buildNewsClass();

        this._buildHotNews();
    },
    methods:{
        handelClass(class_id){
            this.choose_class_id = class_id;
            this.search_base.page = 1;
            this._buildNewsList();
        },
        handelNews(item){
            this.$router.push(`/art_info/detail?id=${item.id}`);
        },
        changePage(e){
            this.search_base.page = e;
            this._buildNewsList();
        },

        _buildNewsClass(){
            getNewsClass().then(api_res=>{
                this.class_list = api_res.data.data||[];
                if(this.class_list.length>0){
                    this.choose_class_id = this.class_list[0].id;
                } 
                this._buildNewsList();
            });
        },

        _buildNewsList(){
            this.loading = true;
            getNews(Object.assign({},this.search_base,{
                class_id : this.choose_class_id
            })).then(api_res=>{
                this.loading = false;
                var list = api_res.data.list;
                var total = api_res.data.total;

                this.search_result.total = total;
                this.search_result.list = list;
            }).catch(err=>{
                this.loading = false;
            })
        },

        

        _buildHotNews(){
            getNews({
                "is_hot" : 1,
                "limit"  : 10,
            }).then(api_res=>{
                this.hot_news = api_res.data.list||[];
            }).catch(err=>{
            })
        }
    }
}
</script>


<style lang="less" scoped>
@import "./index.less";
</style>